// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bread_crumb_wrapper{
    display: flex;
    align-items: center;
}

.bread_crumb_wrapper .home_page {
    font-size: 13px;
}

.current_page{
    text-transform: capitalize;
    color: var(--text-color);
}

.arrow_icon{
    margin:5px 2px;
    font-size: 18px;
}
.arrow_show{
    display: block;
}

.arrow_hide{
    display: none;
}

.cursor_pointer{
    cursor: pointer;
}

.selected_text{
    color:var(--bs-gray-500);
}

.mdi-chevron-right::before {
    color: var(--bs-gray-500);
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/BreadCrumb/BreadCrumb.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".bread_crumb_wrapper{\n    display: flex;\n    align-items: center;\n}\n\n.bread_crumb_wrapper .home_page {\n    font-size: 13px;\n}\n\n.current_page{\n    text-transform: capitalize;\n    color: var(--text-color);\n}\n\n.arrow_icon{\n    margin:5px 2px;\n    font-size: 18px;\n}\n.arrow_show{\n    display: block;\n}\n\n.arrow_hide{\n    display: none;\n}\n\n.cursor_pointer{\n    cursor: pointer;\n}\n\n.selected_text{\n    color:var(--bs-gray-500);\n}\n\n.mdi-chevron-right::before {\n    color: var(--bs-gray-500);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
